var _style, _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMembers = function SvgMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "members_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".members_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.2,
    r: 2.8,
    className: "members_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v3h1.6l.4 5h3l.4-5h1.6z",
    className: "members_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 2.8,
    r: 2.2,
    className: "members_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6c-1.7 0-3 1.3-3 3v2.5H2l.5 4.5h2l.5-4.5h1.5V9c0-1.7-1.3-3-3-3",
    className: "members_svg__st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 2.8,
    r: 2.2,
    className: "members_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6c-1.7 0-3 1.3-3 3v2.5H19l.5 4.5h2l.5-4.5h1.5V9c0-1.7-1.3-3-3-3",
    className: "members_svg__st0"
  })));
};
export default SvgMembers;